// businessSlice.js
import { createSlice } from '@reduxjs/toolkit';

const businessSlice = createSlice({
  name: 'business',
  initialState: {
    name: '',
  },
  reducers: {
    setBusinessName: (state, action) => {
      state.name = action.payload;
    },
  },
});

export const { setBusinessName } = businessSlice.actions;
export const selectBusinessName = (state) => state.business.name;
export default businessSlice.reducer;